import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3944763a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lotr-spinner-3d mb-4 mx-auto" }, null, -1))
const _hoisted_2 = { class: "lotr-text mb-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lotr-quote" }, " \"Todo lo que tenemos que decidir es qué hacer con el tiempo que se nos ha dado.\" ", -1))

import { watch, ref } from "vue";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingLOTR',
  props: {
    isVisible: { type: Boolean },
    mensaje: {}
  },
  emits: ["update:isVisible"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
// eslint-disable-next-line no-undef
const emit = __emit;
const localVisible = ref(props.isVisible);

watch(
  () => props.isVisible,
  val => {
    localVisible.value = val;
  }
);

watch(localVisible, val => {
  if (val !== props.isVisible) {
    emit("update:isVisible", val);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: localVisible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localVisible).value = $event)),
    persistent: "",
    "max-width": "400"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "text-center pa-6 lotr-background" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(_component_v_img, {
                src: "@/assets/images/LOTR_ring.gif",
                "max-width": "120",
                class: "mb-4 mx-auto"
              }),
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.mensaje), 1),
              _hoisted_3,
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["modelValue"]))
}
}

})